import { createFileRoute } from '@tanstack/react-router';
import { SuperAdminDashboard } from '@/pages/super-admin/dashboard/SuperAdminDashboard';

export const Route = createFileRoute('/_authenticated/super-admin/')({
	component: SuperAdminDashboard,
});
